import { GET_SURVEYS } from "constants/surveys";

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_SURVEYS}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
